import { render, staticRenderFns } from "./bidListMgmt.vue?vue&type=template&id=b5e806c2&scoped=true"
import script from "./bidListMgmt.vue?vue&type=script&lang=js"
export * from "./bidListMgmt.vue?vue&type=script&lang=js"
import style0 from "./bidListMgmt.vue?vue&type=style&index=0&id=b5e806c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e806c2",
  null
  
)

export default component.exports